import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { UserActions } from 'src/app/shared/store/user/user.actions';
import { PassportChooser } from '../passport-chooser/passport-chooser';
import { Passport } from '../passport-chooser/passport-chooser.types';
import {
  passportPartners,
  passportPartnersByRegion,
  region,
} from 'src/environment/environment';
import { PassportAuth } from '../../services/passport-auth';
import { ROUTES } from 'src/app/app.routes.constants';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-login',
  imports: [MatCardModule, MatDividerModule, PassportChooser, MatButtonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(Store);
  private langService = inject(LangService);
  private passportAuth = inject(PassportAuth);
  labels = this.langService.lang.core.login;

  passports: Passport[] = (passportPartnersByRegion[region.name] ?? [])
    .map(partnerName =>
      passportPartners.find(({ name }) => name === partnerName),
    )
    .flatMap(partner => (partner ? [partner] : []))
    .map(partner => ({
      name: partner.name,
      url: partner.auth_url,
      label: partner.label,
    }));

  ngOnInit() {
    const params = this.route.snapshot.queryParams;
    const returnUrl = params['returnUrl'] || '';
    localStorage.setItem('returnUrl', returnUrl);
  }

  onAuthenticate() {
    this.store.dispatch(UserActions.authenticate());
  }

  onPassportAuthenticate(passport: Passport) {
    this.passportAuth.setCurrentPartner(passport.name);
    window.location.href = passport.url({
      returnUrl: `${window.location.origin}/${ROUTES.passportCode}`,
    });
    // window.location.href = `${window.location.origin}/${ROUTES.passportCode}?code=mockcode`;
  }
}
